const ACCOUNTS_WITH_API_INBOX_DISABLED = [7];

export const isApiInboxDisabledForAccount = accountId =>
  ACCOUNTS_WITH_API_INBOX_DISABLED.includes(Number(accountId));
